import './fileUploader.scss';

type Props = {
  file: File;
};

export function FileUploader({ file }: Props) {
  const getExtension = (filename = '') => {
    const idx = filename.lastIndexOf('.');
    return idx === -1 ? '' : filename.slice(idx + 1).toUpperCase();
  };

  const MIME_TO_LABEL = {
    'application/pdf': 'PDF',
    'application/vnd.ms-excel': 'CSV',
    'image/jpeg': 'JPG',
    'image/png': 'PNG',
    'text/csv': 'CSV',
    'text/plain': 'TXT'
  };

  const getPrettyType = (file: File) => {
    const ext = getExtension(file?.name);
    if (ext) {
      return ext;
    }

    if (file?.type && file.type in MIME_TO_LABEL) {
      return MIME_TO_LABEL[file.type as keyof typeof MIME_TO_LABEL];
    }

    return file?.type ? file.type.toUpperCase() : 'Unknown';
  };

  const formatMB = (bytes: number, decimals = 1) => {
    return `${(bytes / 1_000_000).toFixed(decimals)} MB`;
  };

  return (
    <div className="fileUploader">
      <div className="fileUploader__fileIcon">
        <i className="fa-light fa-file-csv" />
      </div>
      <div className="fileUploader__fileInfo">
        <span className="fileUploader__fileInfoName">{file.name}</span>
        <span className="fileUploader__fileInfoMeta">
          .{getPrettyType(file)} | {formatMB(file.size, 4)}
        </span>
      </div>
    </div>
  );
}
